import { ErrorCard } from "./ErrorCard.component";

export default ErrorCard;
